export class Role {
  id: number;
  name: string;
  appRoleTypeId: number;
  appRoleTypeName: string;
  description: string;
  isSystem: boolean;
  numberOfUsers: number;
  permissions: string[];
}




// WEBPACK FOOTER //
// ./src/app/core/models/role.ts